import { request } from 'src/api/request';

interface NewExportProps {
  url: string;
  fileFormat: string;
  method?: string;
  columns: string[];
  data?: any;
  fileName?: string;
}

export const getNewExport = ({
  url,
  fileFormat,
  method = null,
  columns,
  data = null,
  fileName,
}: NewExportProps) => {
  return request({
    url: 'v1/admin/export/',
    method: 'POST',
    data: {
      method: method,
      url,
      file_format: fileFormat,
      file_name: fileName,
      columns: columns,
      body: data,
    },
  });
};

export const getExports = async ({ queryParams }) => {
  return await request({
    url: `v1/accounts/exports/${queryParams}`,
    method: 'GET',
  });
};
